import React from "react";
import "@/styles/tabs.css";

type Props = {
    tabs: string[];
    selectedTab: number;
    onChange: (value: number) => void;
};

export default function Tabs({ tabs, selectedTab, onChange }: Props) {
    return (
        <div className="wonmov-tabs">
            {tabs.map(function (tab, index) {
                var itemClass = "wonmov-tabs__item";
                if (selectedTab === index) {
                    itemClass += " wonmov-tabs__item--active";
                }

                return (
                    <button
                        key={index}
                        type="button"
                        className={itemClass}
                        onClick={function () {
                            onChange(index);
                        }}
                    >
                        {tab}
                    </button>
                );
            })}
        </div>
    );
}
